import React, { useEffect } from 'react'
import { message, Form, Modal, Input, Radio, Button, Select, Space } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { updateAttribute, createAttribute } from '@services/attributeService' 
import { showError } from '@utils/alert'

function AttributeValueEdit (props: any) {
  const { value, id, visible, onCancel } = props
  const [form] = Form.useForm()

  useEffect(() => {
    form.resetFields()
    if (!value || !value.id) return
    form.setFieldsValue({
      value: value.value,
      valid: value.valid,
      patterns: value.patterns,
    })
  }, [value, id, form])
  
  const onEditItem = () => {
    form.validateFields().then(values => {
      const hide = message.loading('更新或者创建中...')
      let patterns = values.patterns?.filter(p => Array.isArray(p.terms) || Array.isArray(p.negativeTerms))
      patterns = patterns?.length ? patterns : null
      if (value && value.id) {
        updateAttribute(value.id, {
          value: values.value,
          valid: values.valid,
          patterns: patterns,
        })
        .then(res => {
          hide()
          onCancel && onCancel()
          message.success(`update value ${res.data.id} succeed`)
        })
        .catch(e => {
          hide()
          console.error(e)
          showError('update value failed', e)
        })
      } else {
        createAttribute({
          parent_id: id,
          value: values.value,
          valid: values.valid,
          patterns: patterns,
          type: 0, // type: value
        })
        .then(res => {
          hide()
          onCancel && onCancel()
          message.success(`create value ${res.data.id} succeed`)
        })
        .catch(e => {
          hide()
          console.error(e)
          showError('create value failed', e)
        })
      }
    })
    .catch(e => {
      console.error(e)
      showError('from valid failed', e)
    })
  }

  return (
    <Modal
      title={value ? '更新属性值' : '新建属性值'}
      centered
      width={650}
      closable
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      footer={
        <>
          <Button onClick={onCancel} type="default">取消</Button>
          <Button onClick={onEditItem} type="primary">保存</Button>
        </>
      }
    >
      <Form preserve={false} name="attr-value" form={form} autoComplete="off">
        <Form.Item name="value" label="Name" required>
          <Input />
        </Form.Item>
        <Form.Item name="valid" label="Valid" initialValue={true} required>
          <Radio.Group>
            <Radio value={true}>启用</Radio>
            <Radio value={false}>禁用</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.List name="patterns" initialValue={[{}]}>
          {
            (fields: any, { add, remove }: any) => {
              const fieldItems = fields.map(({ key, name, fieldKey, ...restField }, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: '100%',
                      display: 'inline-flex',
                      marginBottom: 8,
                      alignItems: 'center',
                    }}
                  >
                    <Form.Item
                      name={[name, 'terms']}
                      fieldKey={[fieldKey, 'terms']}
                      label="Terms"
                      style={{ flex: 1, marginRight: '8px' }}
                      {...restField}
                    >
                      <Select mode="tags" tokenSeparators={[',', '，']} />
                    </Form.Item>
                    <Form.Item
                      name={[name, 'negativeTerms']}
                      fieldKey={[fieldKey, 'terms']}
                      label="Neg. Terms"
                      style={{ flex: 1, marginRight: '8px' }}
                      {...restField}
                    >
                      <Select mode="tags" tokenSeparators={[',', '，']} />
                    </Form.Item>
                    {fields.length > 1 ? (
                      <MinusCircleOutlined
                        style={{ marginBottom: '16px' }}
                        onClick={() => remove(name)}
                      />
                    ) : null}
                  </div>
                )
              })
              return (
                <>
                  {fieldItems}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      style={{ width: '60%' }}
                      icon={<PlusOutlined />}
                    >
                      Add Pattern
                    </Button>
                  </Form.Item>
                </>
              )
            }
          }
        </Form.List>
      </Form>
    </Modal>
  )
}

export default AttributeValueEdit
